import React from 'react';
import { IonApp, IonRouterOutlet, setupIonicReact } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { Redirect, Route } from 'react-router';

//	C S S   D E F A U L T S

import '@ionic/react/css/core.css';
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

//	T H E M E   F O N T S

import './theme/theme.fonts/font-awesome/css/all.min.css';
import './theme/theme.fonts/quicksand/quicksand.css';

//	T H E M E

import './theme/theme.variables.scss';
import './theme/theme.global.scss';

//	T Y P E S

import { type___api___response } from './types/types.api-response';
import { type___cookies___accepted } from './types/types.cookies';
import { type___locale___language } from './types/types.locale';

//	S T A T E   -   P R O P S

import { state___App, state___App___default } from './App.state';

//	L I B S

import { lib_names } from './libs/lib.names';

//	F U N C S

import { funcs_platform } from './funcs/funcs.platform';

//	S E R V I C E S

import { service_RestAuthService } from './services/service-auth';
import { service_RestApiService } from './services/service-api';

//	P A G E S

import Sb404Page from './pages/sb-404/sb-404';

import SbDashboardPage from './pages/sb-dashboard/sb-dashboard';

import SbDigitalMenuEditPage from './pages/sb-digitalmenus/sb-digitalmenu-edit-appearance/sb-digitalmenu-edit-appearance';
import SbDigitalMenuEditDishesPage from './pages/sb-digitalmenus/sb-digitalmenu-edit-dishes/sb-digitalmenu-edit-dishes';
import SbDigitalMenuViewPage from './pages/sb-digitalmenus/sb-digitalmenu-view/sb-digitalmenu-view';

import SbInfoCopyrightPage from './pages/sb-info/sb-info-copyright/sb-info-copyright';
import SbInfoDigitalMenuAllergensPage from './pages/sb-digitalmenus/sb-digitalmenu-allergens/sb-digitalmenu-allergens';
import SbInfoEulaPage from './pages/sb-info/sb-info-eula/sb-info-eula';
import SbInfoLicencesPage from './pages/sb-info/sb-info-licences/sb-info-licences';
import SbInfoSupport from './pages/sb-info/sb-info-support/sb-info-support';

import SbLandingLoadingPage from './pages/sb-landing-loading/sb-landing-loading';

import SbLoginPage from './pages/sb-sign/sb-sign';

import SbSettingsMainPage from './pages/sb-settings/sb-settings-main/sb-settings-main';
import SbSettingsAuthenticationPage from './pages/sb-settings/sb-settings-authentication/sb-settings-authentication';

//	M O D A L S

import MdEntryCookiesModal from './modals/md-entry-cookies/md-entry-cookies';
import MdEntryLanguageModal from './modals/md-entry-language/md-entry-language';

//	S E T U P

setupIonicReact({
	mode: 'ios'
});

//	C L A S S

export default class App extends React.Component<{}, state___App> {

//#region 																							D E C L A R A T I O N S

	private _ABORT_CONTROLLER: AbortController | null = null;

	private readonly _AUTH: service_RestAuthService = new service_RestAuthService();
	private readonly _API: service_RestApiService = new service_RestApiService();
	private readonly funcs___platform: funcs_platform = new funcs_platform();

//#endregion

//#region 																							C O N S T R U C T O R

	constructor(
		public props: {},
	) {
		super(props);
		this.state = state___App___default;
		if (!this._ABORT_CONTROLLER) { this._ABORT_CONTROLLER = new AbortController(); }
	}

//#endregion

//#region 																							A B O R T   C O N T R O L L E R

	private AbortController___abort() : void {
		if (this._ABORT_CONTROLLER) { this._ABORT_CONTROLLER.abort(); }
	}

//#endregion

//#region 																							R E A D   P R O P S

	private read_props___me___isLogged = async () => {

		const ___me___isLogged___server_response: type___api___response = await this._AUTH.auth___checklogged();
		const ___me___isLogged: boolean = (___me___isLogged___server_response && ___me___isLogged___server_response['response'] && ___me___isLogged___server_response['response'] === 'success' && ___me___isLogged___server_response['data'] !== null) ? ___me___isLogged___server_response['data'] : false;

		const ___me___isLogged___props___server_response: type___api___response = await this._API.users___read_single('me', null);
		const ___me___isLogged___props: any | null = (___me___isLogged___props___server_response && ___me___isLogged___props___server_response['response'] && ___me___isLogged___props___server_response['response'] === 'success' && ___me___isLogged___props___server_response['data'] !== null) ? ___me___isLogged___props___server_response['data'] : null;

		return this.setState({
			me___isLogged: ___me___isLogged,
			me___isLogged___props: ___me___isLogged___props,
			app___isLoading: false,
		}, async () => {
			if (this.state.me___isLogged === true && this.state.me___isLogged___props !== null) {
				this.setState({ ionModal___MdSignPasswordChangeModal___isOpen: this.state.me___isLogged___props['user_password___is_temporary'] ?? false });
			}
			return;
		});

	}

//#endregion

//#region 																							E N T R Y

	private entry___initialize = () => {
		const ___language___selected: type___locale___language | null = localStorage.getItem(lib_names.localStorage.user___language) as type___locale___language | null;
		this.setState({
			entry___language_selected: ___language___selected
		}, async () => {
			if (___language___selected === null) {
				this.setState({
					ionModal___MdEntryLanguageModal___isOpen: true
				});
			} else {
				if (this.funcs___platform.is_native() === true && this.funcs___platform.get_type() === 'ios') { await this.entry___requestTrackingPermission(); }
				const ___cookies___accepted: type___cookies___accepted = localStorage.getItem(lib_names.localStorage.user___cookies_accepted) as type___cookies___accepted;
				this.setState({
					entry___cookies_accepted: ___cookies___accepted
				}, () => {
					if (!(___cookies___accepted !== null)) { this.setState({ ionModal___MdEntryCookiesModal___isOpen: true }); }
				})
			}
		});
	}

	private entry___requestTrackingPermission = async () => {
	//	try {
	//		const ___tracking_status: AppTrackingStatusResponse = await AppTrackingTransparency.getStatus();
	//		if (___tracking_status['status'] === 'notDetermined') {
	//			const ___tracking_status___result: AppTrackingStatusResponse = await AppTrackingTransparency.requestPermission();
	//			if (___tracking_status___result['status'] === 'authorized') {
	//				const ___tracking_enabled: type___cookies___accepted = 'full';
					localStorage.setItem(lib_names.localStorage.user___cookies_accepted, 'authorized'/*___tracking_enabled*/);
	//			} else {
	//				const ___tracking_disabled: type___cookies___accepted = 'none';
	//				localStorage.setItem(lib_names.localStorage.user___cookies_accepted, ___tracking_disabled);
	//			}
	//		} else {
	//			console.log('Tracking permission status: ', ___tracking_status['status']);
	//		}
	//	} catch (___e: any) {
	//		console.error('Error requesting tracking permission', ___e);
	//	}
	}

	private entry___setup___language = (___l: type___locale___language) => {
		this.setState({
			ionModal___MdEntryLanguageModal___isOpen: false,
			entry___language_selected: ___l
		}, () => {
			this.entry___initialize();
		});
	}

	private entry___setup___cookies = (___ca: type___cookies___accepted) => {
		this.setState({
			ionModal___MdEntryCookiesModal___isOpen: false,
			entry___cookies_accepted: ___ca
		}, () => {
			this.entry___initialize();
		});
	}

//#endregion

//#region 																							H A N D L E R S

	private handle___registerAuthUserDatas = (___user_props: any | null = null) => {
		this.setState({
			me___isLogged: (___user_props !== null) ? true : false,
			me___isLogged___props: ___user_props,
		}, async () => {
			if (this.state.me___isLogged === true && this.state.me___isLogged___props !== null) {
				this.setState({ ionModal___MdSignPasswordChangeModal___isOpen: this.state.me___isLogged___props['user_password___is_temporary'] ?? false });
				await this.read_props___me___isLogged();
				return;
			}
		});
	}

//#endregion

//#region 																							L I F E C Y C L E

	async componentDidMount() : Promise<void> {
		this.AbortController___abort();
		await this.read_props___me___isLogged();
		this.entry___initialize();
	}

	componentWillUnmount() : void {
		this.AbortController___abort();
	}

//#endregion

//#region 																							R E N D E R

	render() : React.ReactNode {
		return <>
			<IonApp>
				<IonReactRouter>
					{(this.state.app___isLoading === true) ? <>
						<SbLandingLoadingPage/>
					</> : <>
						{(this.state.entry___language_selected !== null && this.state.entry___cookies_accepted !== null) ? <>
							{(() => { switch (this.state.me___isLogged) {
								case true: return <>
									<IonRouterOutlet>

										{/*      4 0 4      */}

										<Route path="/404" component={(___p: any) => { return <Sb404Page {...___p} /> }} exact />

										{/*      d a s h b o a r d      */}
									
										<Route path="/dashboard" component={(___p: any) => { return <SbDashboardPage {...___p} is_logged={ this.state.me___isLogged } is_logged___props={ this.state.me___isLogged___props } /> }} exact />

										{/*      d i g i t a l   m e n u      */}

										<Route path="/digitalmenu/view/:id" component={(___p: any) => { return <SbDigitalMenuViewPage {...___p} is_logged={ this.state.me___isLogged } is_logged___props={ this.state.me___isLogged___props } /> }} exact />
										<Route path="/digitalmenu/edit/:id/dishes" component={(___p: any) => { return <SbDigitalMenuEditDishesPage {...___p} is_logged={ this.state.me___isLogged } is_logged___props={ this.state.me___isLogged___props } /> }} exact />
										<Route path="/digitalmenu/edit/:id/appearance" component={(___p: any) => { return <SbDigitalMenuEditPage {...___p} is_logged={ this.state.me___isLogged } is_logged___props={ this.state.me___isLogged___props } /> }} exact />

										{/*      i n f o      */}

										<Route path="/info/copyright" component={(___p: any) => { return <SbInfoCopyrightPage {...___p} /> }} exact />
										<Route path="/info/digitalmenu/allergens" component={(___p: any) => { return <SbInfoDigitalMenuAllergensPage {...___p} /> }} exact />
										<Route path="/info/eula" component={(___p: any) => { return <SbInfoEulaPage {...___p} /> }} exact />
										<Route path="/info/licences" component={(___p: any) => { return <SbInfoLicencesPage {...___p} /> }} exact />
										<Route path="/info/support" component={(___p: any) => { return <SbInfoSupport {...___p} is_logged={ this.state.me___isLogged } is_logged___props={ this.state.me___isLogged___props } /> }} exact />

										{/*      s e t t i n g s      */}

										<Route path="/settings" component={(___p: any) => { return <SbSettingsMainPage {...___p} is_logged={ this.state.me___isLogged } is_logged___props={ this.state.me___isLogged___props } /> }} exact />
										<Route path="/settings/auth" component={(___p: any) => { return <SbSettingsAuthenticationPage {...___p} is_logged={ this.state.me___isLogged } is_logged___props={ this.state.me___isLogged___props } /> }} exact />

										{/*      r e d i r e c t      */}
										
										<Redirect to="/dashboard" />

									</IonRouterOutlet>

								</>; break;
								case false: return <>
									<SbLoginPage event___registerAuthUserDatas={(___user_props: boolean) => { this.handle___registerAuthUserDatas(___user_props); }}/>
								</>; break;
								default: case null: return <>
									<SbLandingLoadingPage/>
								</>; break;
							}})()}
						</> : <>
							<MdEntryCookiesModal isOpen={ this.state.ionModal___MdEntryCookiesModal___isOpen } event___onDidDismiss={ this.entry___setup___cookies }/>
							<MdEntryLanguageModal isOpen={ this.state.ionModal___MdEntryLanguageModal___isOpen } isDismissible={ false }  event___onDidDismiss={ this.entry___setup___language }/>
							<SbLandingLoadingPage/>
						</>}
					</>}

				</IonReactRouter>
			</IonApp>
		</>;
	}

//#endregion

}